import {showCopyableIdTooltip} from '@utils/eventDetailsHelper';

export const secondStageCategoryName = (event) => {
    const baseName = event.st_event.stage
        ? event.st_event?.stage?.stage_category?.name
        : event.st_event?.stage_category?.name;

    const tierName = event?.propertyLicenceContent?.content_tier?.name;

    return  tierName ? `${baseName} (${tierName})`: baseName;
};

const secondStageCategoryId = (event) =>
    event.st_event?.stage?.stage_category?.id ?? event.st_event?.stage_category?.id;

export const secondStageCategory = (event) => showCopyableIdTooltip(
    secondStageCategoryName(event),
    secondStageCategoryId(event),
    'Stage category'
);
